import { CollapsableQuestion } from 'components/collapsableQuestion/collapsableQuestion';
import { StandardLayout } from 'layouts/standardLayout/standardLayout';
import { useCSBTransitionPage } from 'pageHooks/csbTransitionHooks';
import * as pageClasses from 'pages/csb-transition.module.scss';
import * as React from 'react';
import { Helmet } from 'react-helmet';

const CSBTransitionPage: React.FC = () => {
  const { questionsWithAnswers } = useCSBTransitionPage();

  return (
    <main>
      <Helmet htmlAttributes={{ lang: 'en' }}>
        <title>ScheduleLab - CSB Transition</title>
        <meta charSet="utf-8" />
      </Helmet>

      <StandardLayout title="Moving to ScheduleLab from College Schedule Builder">
        <article className={pageClasses.questionsAndAnswers}>
          {questionsWithAnswers.map((questionWithAnswer) => (
            <CollapsableQuestion key={questionWithAnswer.question} {...questionWithAnswer} />
          ))}
        </article>
      </StandardLayout>
    </main>
  );
};

export default CSBTransitionPage;
